import { inject } from '@angular/core';
import { Router, CanMatchFn } from '@angular/router';
import { RoleEnum } from '../../common/interfaces/token/role-enum';
import { ColorStop } from '@hubspot/api-client/lib/codegen/cms/blogs/blog_posts';
import { USER_TOKEN } from './user-token.util';
import { UserService } from '../services/user/user.service';

// Function-based guard factory
export const AuthGuard: (...allowedRoles: RoleEnum[]) => CanMatchFn = (...allowedRoles: RoleEnum[]) => {
  return () => {
    const token = inject(USER_TOKEN).getValue()
    const router = inject(Router);
    const userService = inject(UserService);

  if (token !== null && token.UserRoles.includes(RoleEnum.Admin) || allowedRoles.some(role => token.UserRoles.includes(role))) {
    return true;
  }
    userService.loginRedirect();
    return false;
  };
};
